import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import DatePicker from "react-datepicker";
import TxnList from "./TxnList";
import useUniversalStore from "store/universalStore";
import ExpandableButton from "components/ExpandableButton";

function Home() {
  const { write, selectedMonth } = useUniversalStore((state) => state);
  const [animation, setAnimation] = useState("");
  const [hideCancelled, setHideCancelled] = useState(false);
  const isToday = dayjs(selectedMonth).isSame(dayjs(), "day");

  useEffect(() => {
    write({ selectedMonth: new Date() });
  }, []);

  const prevDate = async () => {
    const newDate = dayjs(selectedMonth).subtract(1, "days").toDate();
    write({ selectedMonth: newDate });
    setAnimation("animate__animated animate__slideInRight fast-animation");
  };

  const nextDate = async () => {
    if (isToday) return;
    const newDate = dayjs(selectedMonth).add(1, "days").toDate();
    write({ selectedMonth: newDate });
    setAnimation("animate__animated animate__slideInLeft fast-animation");
  };

  // const handleDate = (year,month,day)=>{
  //   let newDate = new Date(year,month);
  //   console.log("new Date ",newDate);
  //   setDate(newDate);
  // }

  const handleDate = (date) => {
    write({ selectedMonth: date });
  }

  return (
    <div className="background">
      <div className="row py-2 g-0 align-items-center border-bottom">
        <div className="col-2 col-md-1 d-flex justify-content-center">
          <i className="bi bi-arrow-left-circle-fill fs-3 fs-md-2 border-0 p-1 text-app cursor-pointer"
            onClick={prevDate}
          />
        </div>
        <div className="col-8 col-md-10 my-1 d-flex gap-2 justify-content-center align-items-center ">
          <div className="datepicker-container d-flex align-items-center">
            <DatePicker
              selected={selectedMonth}
              onChange={(value) => write({ selectedMonth: value })}
              onKeyDown={(e) => e.preventDefault()}
              dateFormat="dd-MMM-yyyy"
              maxDate={new Date()}
              className="bg-app p-1 fs-6 fs-md-5 text-center w-auto text-white border-1 shadow-none rounded-2"
              showIcon
              icon={<i className="bi bi-calendar-date text-white py-1 fs-6 fs-md-5"></i>}
            />
          </div>

          <i className={`fs-3 fs-md-2 text-app cursor-pointer 
              ${hideCancelled ? "bi-filter-circle-fill" : "bi-filter"}`}
            onClick={() => setHideCancelled(!hideCancelled)}></i>

        </div>
        <div className="col-2 col-md-1 d-flex justify-content-center" align="right">
          <i className={`bi fs-3 fs-md-2 text-app p-1 ${!isToday ? "bi-arrow-right-circle-fill cursor-pointer" : "bi-arrow-right-circle opacity-50"}`}
            onClick={nextDate}
          />
        </div>
      </div>

      <TxnList
        animation={animation}
        setAnimation={setAnimation}
        hideClosed={hideCancelled} />

      <div className="addTxn-btn" style={{ bottom: "90px" }}>
        <ExpandableButton
          title="New Entry"
          formId="newTxn"
          // onClick={(e) => goToNextStep()}
          icon="bi bi-pencil-fill"
        />
      </div>
    </div>
  );
}

export default Home;
